























































































































import { Component, Vue } from 'vue-property-decorator';
import SectionTuileNav from '@/components/shared/SectionTuileNav.vue'
import { ITuileNav } from '@/models/ui/ITuileNav';

@Component({
  name:"Domicile",
  components: { SectionTuileNav
  },
})
export default class Domicile extends Vue {
  
  private arianeItems = [
        {
          text: 'Accueil',
          disabled: false,
          to: {name:'Home'},    
          exact:true      
        },
        {
          text: 'Cours de natation à domicile',
          disabled: true          
        },
      ]
}
